import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgConstantsIcon(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={27} height={27} fill="none" viewBox="0 0 27 27" {...props}>
            <G clipPath="url(#clip0)">
                <Path
                    fill="#F6B863"
                    d="M5.724 21.617h14.737v1.488H5.724v-1.488zm9.941-18.58h1.776L16.875.686a.864.864 0 10-1.678.409l.468 1.942z"
                />
                <Path
                    fill="#F6B863"
                    d="M22.954 25.932L20.52 15.816h-1.776l2.533 10.524a.865.865 0 101.678-.408zM6.147 15.816L3.713 25.931a.864.864 0 001.678.41l2.533-10.525H6.147zM11 3.038l.467-1.941A.864.864 0 109.79.688l-.566 2.35H11z"
                />
                <Path
                    fill="#DBD8DD"
                    d="M1.927 1.805h23.145c.51 0 .923.413.923.923v15.12c0 .51-.413.923-.923.923H1.927a.923.923 0 01-.923-.923V2.728c0-.51.414-.923.923-.923z"
                />
                <Path fill="#EEEFEE" d="M2.14 2.94h22.72v14.694H2.14V2.94z" />
                <Path
                    fill={baseColors.green.primary}
                    d="M21.466 8.045v8.46H5.536v-3.647l5.934-3.94 3.13 3.62 6.866-4.493z"
                />
                <Path
                    fill="#575B6D"
                    d="M5.535 10.288V9.59l5.987-3.974 3.131 3.62 6.813-4.456v.695l-6.92 4.527-3.128-3.618-5.883 3.904z"
                />
                <Path
                    fill={baseColors.orange.primary}
                    d="M14.6 10.711a1.164 1.164 0 100-2.327 1.164 1.164 0 000 2.327z"
                />
                <Path fill="#EB6800" d="M21.275 6.403a1.164 1.164 0 100-2.327 1.164 1.164 0 000 2.327z" />
                <Path fill={baseColors.black} d="M11.493 7.107a1.164 1.164 0 100-2.328 1.164 1.164 0 000 2.328z" />
                <Path fill="#2CBFAE" d="M5.724 10.998a1.164 1.164 0 100-2.327 1.164 1.164 0 000 2.328z" />
            </G>
            <Defs>
                <ClipPath id="clip0">
                    <Path fill="#fff" d="M0 0h27v27H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgConstantsIcon
